/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MonitoringTimeHistoryPeriodDTO } from './MonitoringTimeHistoryPeriodDTO';
import {
    MonitoringTimeHistoryPeriodDTOFromJSON,
    MonitoringTimeHistoryPeriodDTOFromJSONTyped,
    MonitoringTimeHistoryPeriodDTOToJSON,
} from './MonitoringTimeHistoryPeriodDTO';

/**
 * 
 * @export
 * @interface MonitoringTimeHistoryDTO
 */
export interface MonitoringTimeHistoryDTO {
    /**
     * 
     * @type {Array<MonitoringTimeHistoryPeriodDTO>}
     * @memberof MonitoringTimeHistoryDTO
     */
    results: Array<MonitoringTimeHistoryPeriodDTO>;
}

/**
 * Check if a given object implements the MonitoringTimeHistoryDTO interface.
 */
export function instanceOfMonitoringTimeHistoryDTO(value: object): value is MonitoringTimeHistoryDTO {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function MonitoringTimeHistoryDTOFromJSON(json: any): MonitoringTimeHistoryDTO {
    return MonitoringTimeHistoryDTOFromJSONTyped(json, false);
}

export function MonitoringTimeHistoryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTimeHistoryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(MonitoringTimeHistoryPeriodDTOFromJSON)),
    };
}

export function MonitoringTimeHistoryDTOToJSON(value?: MonitoringTimeHistoryDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(MonitoringTimeHistoryPeriodDTOToJSON)),
    };
}

